import type { Select } from '@table-library/react-table-library/select'
import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { Coupon } from 'features/coupons/molecules/Coupon/Coupon'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CouponItem, CouponsRes } from 'features/coupons/types/coupons.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	coupons: CouponsRes
	select: Select
	getMenuOptions: (coupon: CouponItem) => Option[]
}

export const TableSection = ({ coupons, select, getMenuOptions }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ getMenuOptions })

	const results = coupons.data.results
	const isPaginated = !!(coupons.data.next || coupons.data.previous)

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((coupon) => (
						<Coupon key={coupon.id} coupon={coupon} menuOptions={getMenuOptions(coupon)} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={false}
					select={select}
					customStyles={getCardTableStyles(columns, { clickableRows: false })}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground">
				<span>
					{isPaginated
						? t('{{ count }} entries', { count: results.length })
						: t('{{ count }} of {{ total }} entries', {
								count: results.length,
								total: results.length
							})}
				</span>
				<Pagination
					prev={coupons.data.previous}
					next={coupons.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
